<template>
  <dn-ad-preview
    v-if="isPreview"
    :id="id"
    title="Banner Card"
    class="dn-ma-frame"
  />
  <div
    v-else
    :id="id"
    ref="target"
    class="dn-ma-frame"
  />
</template>
<script setup lang="ts">
const { $braze } = useNuxtApp();
const props = defineProps({
  id: {
    type: String,
    required: true
  }
});
const isPreview = inject<Ref<boolean>>('isPreview', ref(false));
const target = ref(null);
onMounted(() => {
  /*
   * This will place the banner card if the composable missed to place it for
   * client side navigation
   */
  if ($braze && !isPreview.value) {
    const banner = $braze.getBanner(props.id);
    if (banner && target.value) {
      $braze.insertBanner(banner, target.value);
      if (banner.isControl) {
        target.value.style.display = 'none';
      }
    }
  }
});
</script>

<style lang="scss">
.dn-ma-frame {
  --_dn-ma-frame_width: var(--dn-ma-frame_width, var(--front-top-content-width));

  inline-size: min(var(--_dn-ma-frame_width), 100vw - var(--site-padding) * 2);
  overflow: hidden;

  &:empty {
    position: absolute;
    margin: 0;
    padding: 0;
    height: 0
  }

  .dn-article & {
    &:empty {
      margin-bottom: 0;
    }

    &-top {
      &:not(:empty) {
        position: relative;
        margin-top: var(--row-gap);
        margin-left: auto;
        margin-right: auto;
        z-index: 8;
      }
    }
  }

  iframe {
    display: block;
  }

  &-headercta {
    inline-size: 100px;
  }

  &-bottom-sticky {
    position: fixed;
    bottom: 0;
    inline-size: 100vw;
    max-width: 100vw;
    z-index: 11;
  }
}
</style>
